/*
 * @Author: M.D.
 * @Date: 2019-12-30 14:41:44
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
const app = {
  state: {
    curLoc: [],
    searchTxt: '',
    showInvoice: false,
    orders: []
  },
  mutations: {
    'SET_ORDERS': (state, val) => {
      state.orders = val
    },
    'SET_CUR_LOC': (state, val) => {
      state.curLoc = val
    },
    'SET_SEARCH_TXT': (state, val) => {
      state.searchTxt = val
    },
    'CLEAR_SEARCH_TXT': (state) => {
      state.searchTxt = ''
    },
    'TOGGLE_INVOICE_INFO': (state, val) => {
      state.showInvoice = val
    }
  },
  actions: {
    setCurLoc: ({ commit }, val) => {
      return commit('SET_CUR_LOC', val)
    },
    setSearchTxt: ({ commit }, val) => {
      return commit('SET_SEARCH_TXT', val)
    },
    clearSearchTxt: ({ commit }) => {
      return commit('CLEAR_SEARCH_TXT')
    },
    toggleInvoiceInfo: ({ commit }, val) => {
      return commit('TOGGLE_INVOICE_INFO', val)
    }
  }
}

export default app
